import { render, staticRenderFns } from "./AppBanner.vue?vue&type=template&id=483d609f&scoped=true&"
import script from "./AppBanner.vue?vue&type=script&lang=ts&"
export * from "./AppBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AppBanner.vue?vue&type=style&index=0&id=483d609f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d609f",
  null
  
)

export default component.exports